import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useApi } from "../../api";
import { n2, printHtml } from "../../lib/format";
import { monthLabel, payslipHtml, payslipLines } from "../../lib/hrDocs";
import { Notice } from "../../lib/ui";

/* Payslip - view only (route /payslip/:id). Admins can open anyone's; staff only their own completed payslips. Print = A4 / PDF. */

export default function Payslip({ user }) {
  const api = useApi();
  const { id } = useParams();
  const [s, setS] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => { api.get(`/api/hr/payslips/${id}`).then(setS).catch((e) => setError(e.message)); }, [api, id]);
  const back = user?.role === "admin" ? ["/payroll?step=payslips", "Payroll"] : ["/my_hr", "My payslips & leave"];
  const L = s && payslipLines(s);
  return (
    <main className="pg" style={{ maxWidth: "50rem" }}>
      <nav className="crumbs no-print"><Link to="/dashboard">Home</Link><i className="fas fa-chevron-right" /><Link to={back[0]}>{back[1]}</Link><i className="fas fa-chevron-right" /><span>Payslip</span></nav>
      <Notice notice={error && { tone: "err", text: error }} />
      {s && (
        <section className="panel" style={{ padding: "1.5rem 1.75rem" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: "1rem", flexWrap: "wrap", borderBottom: "3px solid var(--brand)", paddingBottom: ".9rem", marginBottom: "1rem" }}>
            <div><h1 style={{ margin: 0, fontSize: "1.35rem", color: "var(--brand)" }}>Payslip · {monthLabel(s.payment_month)}</h1>
              <p style={{ margin: ".2rem 0 0", color: "var(--muted)" }}>{s.client_name} · {s.position || "–"} · Staff no. {s.staff_id}</p></div>
            <button type="button" className="btn primary no-print" onClick={() => printHtml(payslipHtml(s))}><i className="fas fa-print" /> Print / save PDF</button>
          </div>
          <div className="grid2" style={{ marginBottom: 0 }}>
            <div><h3 style={{ fontSize: ".9rem", margin: "0 0 .5rem" }}>Earnings</h3>
              <table className="tbl"><tbody>{L.earn.map(([k, v]) => <tr key={k}><td>{k}</td><td className="num mono">{n2(v)}</td></tr>)}
                <tr className="fs-total"><td>Gross pay</td><td className="num mono">{n2(L.gross)}</td></tr></tbody></table></div>
            <div><h3 style={{ fontSize: ".9rem", margin: "0 0 .5rem" }}>Deductions</h3>
              <table className="tbl"><tbody>{L.ded.map(([k, v]) => <tr key={k}><td>{k}</td><td className="num mono">{n2(v)}</td></tr>)}
                <tr><td style={{ color: "var(--muted)", paddingLeft: "1.2rem" }}>of which PAYE</td><td className="num mono" style={{ color: "var(--muted)" }}>{n2(s.paye_tax)}</td></tr>
                <tr><td style={{ color: "var(--muted)", paddingLeft: "1.2rem" }}>of which pension</td><td className="num mono" style={{ color: "var(--muted)" }}>{n2(s.pension_contribution)}</td></tr></tbody></table></div>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "1.2rem", padding: "1rem 1.2rem", background: "var(--brand-soft)", borderRadius: ".9rem" }}>
            <span style={{ fontWeight: 600 }}>Net pay</span><b className="mono" style={{ fontSize: "1.5rem", color: "var(--brand-ink)" }}>TZS {n2(s.net_salary)}</b></div>
          <p style={{ fontSize: ".8rem", color: "var(--muted)", margin: ".8rem 0 0" }}>Employer pension contribution (not deducted from pay): TZS {n2(s.employer_pension)}. Status: {s.payment_status}.</p>
        </section>
      )}
    </main>
  );
}
